<template>
  <div class="page-wrap">
    <div v-if="title">
      <div>
        <div slot="header" class="clearfix" style="border-bottom:0px; padding-top:20px; padding-left:1%;">
          <h3 style="font-size: 16px;color: #00C57D;">{{title}}</h3>
          <div style="border-bottom: 1px solid #eeeeee;padding: 0px 0px;margin: 0 10px 0 0;margin-bottom: 10px"></div>
        </div>
      </div>
      <div>
        <slot></slot>
      </div>
    </div>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>

<script>
  export default {
    name: "PageWrapper",
    props: {
      title: String
    }
  };
</script>
<style lang="scss" scoped>
  .page-wrap {
    padding: 30px 10px 5px;
  }
</style>
